// ════════════════════════════════════════════════════════════════════════
//  Woran sich die Führung abhaken lässt
//
//  Aus DERSELBEN Abfrage, die die Lehrgangsliste ohnehin macht: `useCurricula`
//  liefert je Lehrgang, ob ein Entwurf offen ist und wer ihn angelegt hat. Die
//  Führung kostet damit auf keiner Seite eine zusätzliche Anfrage - und auf
//  /lehrgaenge gar nichts.
//
//  WARUM `created_by` UND NICHT NUR „HAT EINEN ENTWURF“
//
//  Ein Entwurf gehört dem LEHRGANG, nicht der Person. Öffnete ihn eine
//  Kollegin, hakte sich die Station bei allen ab - und die einzige gemessene
//  Station der ganzen Führung wäre eine, die nichts über den Menschen sagt, der
//  gerade davorsitzt.
//
//  WELCHER LEHRGANG DAS ZIEL IST
//
//  Der mit dem EIGENEN Entwurf zuerst. Das ist nicht nur Höflichkeit: die
//  Stationen 3 bis 5 zeigen auf Seiten INNERHALB eines Lehrgangs, und „Neue
//  Lektion“ gibt es dort überhaupt nur, solange ein Entwurf offen ist. Wer schon
//  einen hat, soll dorthin geführt werden und nicht in einen fremden
//  schreibgeschützten Lehrgang, in dem der markierte Knopf fehlt.
//
//  Sonst der erste ohne jeden Entwurf - dort lässt sich einer anlegen. Ist jeder
//  Lehrgang durch einen FREMDEN Entwurf belegt (es gibt höchstens einen je
//  Lehrgang), bleibt null: die Station hat dann kein Ziel und keine Marke. Ein
//  Ring um „Neuer Entwurf“ zeigte sonst auf einen Knopf, den es dort nicht gibt.
// ════════════════════════════════════════════════════════════════════════

import type { TourFacts } from "./tour.js";

/** Was die Führung aus der Lehrgangsliste erfährt. */
export type CourseFact = {
  readonly slug: string;
  readonly retiredAt: string | null;
  readonly hasDraft: boolean;
  /** Wer den offenen Entwurf angelegt hat. Null: keiner offen, oder aus dem Bestand. */
  readonly draftBy: string | null;
};

export function factsFrom(
  courses: readonly CourseFact[] | undefined,
  userId: string,
): TourFacts {
  // Stillgelegte kommen als Ziel nicht in Frage: sie sind aus dem Verkehr
  // gezogen, und eine Führung, die dort hineinführt, empfiehlt Arbeit an einem
  // Lehrgang, den niemand mehr bekommt.
  const list = (courses ?? []).filter((course) => course.retiredAt === null);

  const eigener = list.find((course) => course.hasDraft && course.draftBy === userId);
  const frei = list.find((course) => !course.hasDraft);

  return {
    hasOwnDraft: eigener !== undefined,
    slug: (eigener ?? frei)?.slug ?? null,
  };
}
